export { default } from "./default-error-page-frame";
export * from "./default-error-page-frame";
